<template>
  <div class="home1">
    <div class="wrap">
      <div class="header">
        <h1 class="icon logo">
          <a
            class="wh100"
            href="javascript:;"
            @click="$router.push({ name: 'crossgate.tw' })"
            ><span class="none">永恒岛M</span></a
          >
        </h1>
        <ul class="nav">
          <li class="">
            <a
              href="javascript:;"
              @click="$router.push({ name: 'crossgate.tw' })"
              >官網首頁<br /><i>HOME</i></a
            >
          </li>
          <li class="">
            <a
              href="javascript:;"
              @click="$router.push({ name: 'crossgate.policy' })"
              >隱私政策<br /><i>PRIVACY POLICY</i></a
            >
          </li>
          <li class="">
            <a href="javascript:;">服務條款<br /><i>Terms Of Use</i></a>
          </li>
          <li class="">
            <a href="https://www.facebook.com/CrossGate.TW/" target="_black">
              <img :src="require('../../../../public/image/4.png')" alt="" />
            </a>
          </li>
          <li class="">
            <a href="https://discord.gg/wzMReVas33" target="_black">
              <img :src="require('../../../../public/image/5.png')" alt="" />
            </a>
          </li>
        </ul>
      </div>
      <div class="clearfix sectionInM">
        <div class="title">
          <a href="javascript:;" @click="$router.push({ name: 'crossgate.tw' })"
            >首頁</a
          ><span>&gt;</span>服務條款
        </div>
        <div class="content">
          <div class="article">
            <div class="Section0" style="layout-grid: 15.6pt">
              <h1
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <b
                  ><span
                    style="
                      mso-spacerun: 'yes';
                      font-family: PMingLiU;
                      color: rgb(51, 51, 51);
                      letter-spacing: 0pt;
                      font-weight: bold;
                      font-style: normal;
                      font-size: 24pt;
                      mso-font-kerning: 22pt;
                    "
                  >
                    <font face="PMingLiU">服務條款</font>
                  </span></b
                ><b
                  ><span
                    style="
                      mso-spacerun: 'yes';
                      font-family: 宋体;
                      font-weight: bold;
                      font-size: 24pt;
                      mso-font-kerning: 22pt;
                    "
                  >
                  </span
                ></b>
              </h1>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                >
                  <font face="PMingLiU">
                    本遊戲服務合約（下稱「本合約」）適用於此游戲玩家透過電腦、智慧型裝置或其他電子化載具，連結網際網路至此游戲指定之伺服器所進行的連線遊戲服務締結之定型化契約，並載明應有權利、義務和所適用的條件與條款等資料，同時記載本公司應負之責任。
                  </font> </span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                >
                  <font face="PMingLiU">
                    為保障乙方的權益，請在註冊成為本公司會員前，詳細閱讀條款並經三日以上審閱，以保障乙方的權益。乙方點擊同意鍵後，即推定乙方已閱讀並同意遵守本合約所有條款之會員規範，以及本合約其後所有增刪修改之內容，如乙方不同意本合約條款或使用規範，請勿註冊帳號或使用本服務。乙方於點擊同意鍵時，亦推定乙方願遵守相關法律規定，且相關法律規定如有修改時，亦同。
                  </font> </span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                >
                  <font face="PMingLiU">
                    如乙方為無行為能力人（未滿七歲之未成年人），應由其法定代理人代為之；若為限制行為能力人（滿七歲但未滿二十歲），應於乙方的正式代理人閱讀，了解並同意本服務條款之所有內容及其後修改變更後，方得使用或繼續使用本服務。
                  </font> </span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                >
                  <font face="PMingLiU">
                    乙方確認乙方已經審閱本條款並完全同意本條款內容。由於本條款的內容甲方可能隨時修改，請注意定時或不定時瀏覽本條款最新版本的內容。使用甲方的網站，即表示乙方確認，同意受本條款修正後之規範。</font
                  > </span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                >
                  <font face="PMingLiU"
                    >乙方同意以電子方式訂定本條款，並同意本條款及乙方所有瀏覽記錄可以電磁記錄的形式被保存。</font
                  > </span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                >
                  <font face="PMingLiU"
                    >第一條：認知與接受條款立約人及其基本資料：</font
                  > </span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                  >1.&nbsp;共和國科技有限公司（以下簡稱「甲方」）係指利用網路提供線上服務之人。</span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                >
                  <font face="PMingLiU">代表人：朱昱勳</font> </span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                >
                  <font face="PMingLiU">電子郵件：</font
                  >info@insaneew.com </span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                >
                  <font face="PMingLiU"
                    >營業所地址：台北市大安區和平東路二段</font
                  >307號3樓 </span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                >
                  <font face="PMingLiU">統一編號：</font>89115363 </span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                  >2.&nbsp;茲因該游戲提供此項會員服務，會員系統服務使用者（以下簡稱「乙方」），請利用甲方所提供的註冊方式完成會員資料登記。</span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                  >3.&nbsp;上述甲方與乙方基於本服務提供合約（以下稱「本合約」）雙方訂定條款如下。</span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                >
                  <font face="PMingLiU">第二條：合約書適用之範圍</font> </span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                >
                  <font face="PMingLiU"
                    >甲方提供乙方網路連線遊戲服務及其他相關服務（以下簡稱本服務），甲乙雙方關於本服務之權利義務，依本合約書條款之約定協議之。</font
                  > </span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                >
                  <font face="PMingLiU">第三條：合約之內容</font> </span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                >
                  <font face="PMingLiU"
                    >以下視為本合約之一部分，與本合約條款具有相同之效力：</font
                  > </span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                  >1.&nbsp;甲方有關本遊戲服務之廣告或宣傳內容。</span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                  >2.&nbsp;收費制遊戲之費率表及遊戲管理規則。</span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                >
                  <font face="PMingLiU">第四條：名詞定義</font> </span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                >
                  <font face="PMingLiU">本合約之名詞定義如下：</font> </span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                  >1.&nbsp;線上遊戲：係指乙方透過網際網路連接到甲方所架設之網路伺服器，使乙方得與其他不特定之眾多數人得同時連線進行遊戲之軟體。</span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                  >2.&nbsp;遊戲網站：係指由甲方為提供甲方服務所建置之網站。</span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                  >3.&nbsp;遊戲管理規範：係指由甲方專供為規範遊戲進行方式，會員行為規範等相關規範。</span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                  >4.&nbsp;遊戲歷程：係指乙方進行甲方遊戲時，甲方伺服器系統可提供之電磁記錄。</span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                  >5.&nbsp;儲值：係指乙方支付甲方之金額。</span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                  >6.&nbsp;外掛程式：除甲方提供之線上遊戲程式、服務程式與乙方電腦設備之作業系統程式，輔助作業系統運作之相關程式，連接網際網路所需之必要程式外，非甲方所提供或包括但不限於以下：按鍵精靈/連點程式/自動練功/開圖程式/輔助程式…等軟體。</span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                  >7.&nbsp;開始遊戲：係指乙方使用甲方所提供的帳號，進行甲方所提供之各項線上遊戲服務時。</span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                  >8.&nbsp;遊戲套件：係指能完整執行本遊戲全部功能之軟體。</span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                  >9.&nbsp;下載相關軟體：係指由網路下載前項遊戲套件之行為。</span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                  >10.&nbsp;必要成本：係指甲方為提供各項服務，已支出或已給付，預付予第三人之費用。</span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                  >11.&nbsp;扣除必要成本：係指替換依最新比值轉換新台幣後的未使用點數或引用點數匯總30％之計算方式，且另外再加上匯款轉帳手續費新台幣30元之費用。</span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                  >12.&nbsp;程式錯誤（BUG）：非甲方設計遊戲程序時所預見或規劃之遊戲呈現方式，操作模式或所表現之錯誤遊戲結果。</span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                >
                  <font face="PMingLiU">第五條：服務範圍</font> </span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                  >1.&nbsp;本合約書所提供的服務，係由甲方提供網路伺服器，供乙方透過網際網路連線登錄進行甲方遊戲。但此不包括乙方向網際網路接取服務業者申請接取網際網路之服務，及提供上網所需之自身軟、硬體設備（乙方自行配備上網所需的外接電腦設備、行動裝置，以及負擔「網際網路連線費」或「電話費」等電信相關費用）。</span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                  >2.&nbsp;電磁資料、紀錄之所有權，屬甲方及其所約定人所有。</span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                  >3.&nbsp;乙方僅得依本服務條款之約定使用各項服務，不得出租、出借、移轉或私下出售讓與給其他第三人使用。</span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                  >4.&nbsp;甲方有權變更或取消本服務相關系統功能之全部或一部分，乙方不得異議。</span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                  >5.&nbsp;乙方應正確利用甲方及合作廠商所使用之儲值方式，以使用本遊戲提供之購買服務。</span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                  >6.&nbsp;若乙方使用虛偽不正或違法之方式進行「儲值」，甲方有權隨時終止會員資格並停止其使用權。</span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                >
                  <font face="PMingLiU">第六條：遊戲登錄</font> </span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                  >1.&nbsp;乙方申請註冊帳號時，基於誠實信用原則需擔負真實登錄義務，乙方保證所提供的填寫資料存檔真實和正確無誤。</span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                  >2.&nbsp;當個人資料有變更者，需立即更新以維持資料正確及完整並保障乙方權益，如因乙方所提供的個人資料不實或個人資料有異動未立即更新，致與原登錄之資料不符時。甲方得視情況終止會員資格並停止提供本服務。</span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                  >3.&nbsp;如因資料不實或冒用他人名義以致於侵害他人或違法時，乙方應自負法律責任及相關損失。</span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                  >4.&nbsp;乙方之會員資訊如有修改之需求，乙方需提供可供甲方驗證是否為本人之資訊，經甲方驗證完成後可進行修改。如乙方未能提供驗證所需之資料，甲方有權拒絕乙方進行修改。</span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                  >5.&nbsp;如乙方於『一年』內未曾有登錄甲方各項服務之記錄，甲方將依乙方登錄之通訊資料通知乙方應於十五日內登錄甲方；如屆期仍未有乙方登錄甲方之記錄，甲方有權逕行刪除乙方之帳號，遊戲角色，紀錄等相關資料，但法令另有規定者不在此限。</span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                >
                  <font face="PMingLiU">第七條：遊戲點數</font> </span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                  >1.&nbsp;乙方應在經甲方認可之合作廠商購買遊戲點數。遊戲點數僅適用於部分由甲方提供的產品和服務。</span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                  >2.&nbsp;遊戲點數經儲值在甲方後，即無法轉讓給他人或其他帳號，除非法律規定或本合約另有約定外，遊戲點數均不可由平台兌換或退回為任何金錢或等值商品。</span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                  >3.&nbsp;乙方購買遊戲點數或兌換商品及服務，應予以審閱本合約條款和甲方銷售協議。</span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                  >4.&nbsp;乙方應全權負責核對遊戲點數的增加及使用狀況，並確保帳號點數來源合法。</span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                  >5.&nbsp;如甲方接獲合作廠商或司法相關單位的來函通知乙方的帳號或點數有異常，則甲方有權暫停或終止乙方的會員服務或其他功能的權利。</span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                >
                  <font face="PMingLiU">第八條：收費標準</font> </span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                  >1.&nbsp;本會員系統服務所提供的遊戲服務為免費制。另遊戲服務內部如有提供需乙方額外補充購買之點數、商品或其他服務，甲方將在官網首頁，遊戲登錄頁面或購買頁面公告載明付款方式及商品資訊。</span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                  >2.&nbsp;相關費用或費率如有調整時，應自調整日起按新費率計收。費率調整時，甲方應於預定調整日三十日前於官網首頁、遊戲登錄頁面或購買頁面公告；若乙方於註冊帳號時已登錄通訊資料者，並依乙方登錄之通訊資料通知乙方。</span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                  >3.&nbsp;費率如有調整時，應自調整日起按新費率計收；若新費率高於舊費率時，乙方在新費率生效日前已於官網中登錄之估計購買點數或遊戲費用應依舊費率計收。</span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                >
                  <font face="PMingLiU">第九條：甲方應載明之資訊</font> </span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                >
                  <font face="PMingLiU"
                    >甲方應於官網首頁、遊戲登錄頁面或購買頁面上載明以下事項。</font
                  > </span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                  >1.&nbsp;依遊戲軟體分級管理方法規定標示遊戲等級等級及禁止或適合使用之年齡層。</span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                  >2.&nbsp;進行本遊戲服務之最低軟硬體需求。</span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                  >3.&nbsp;有提供獲得購買之機會中獎商品或活動，其活動內容、變量，中獎及機率或稀有商品數量等資訊，並應註明「此為機會中獎商品，消費者購買或參與活動不代表即可獲得特定商品」等提示。</span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                >
                  <font face="PMingLiU"
                    >第十條：遊戲套件與軟體之退費</font
                  > </span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                  >1.&nbsp;乙方得於下載甲方套件或購買相關軟件後七日內，以書面通知甲方解除本合約，乙方無需說明理由和負擔任何費用。</span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                  >2.&nbsp;依據前項事實，乙方得就未使用之所購買點數向甲方請求退費。</span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                  >3.&nbsp;部分甲方所提供的遊戲軟件，產品套件及遊戲內商品或服務，屬於行政院消費者保護處公告之「通訊交易解除權合理例外情事適用準則」所規定的特殊商品，一經購買或接受服務即不適用消費者保護法第十九條七日解除權之規定，乙方不得請求甲方對特殊商品之退費。</span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                >
                  <font face="PMingLiU">第十一條：合約之效力</font> </span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                  >1.&nbsp;乙方於合約審閱期過後初次註冊帳號，進入顯示本合約條款之網頁，並按「同意」之選項後，即推定乙方同意本合約條款之規定。</span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                  >2.&nbsp;本合約若任何一部無效，不影響其他部份之效力。</span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                >
                  <font face="PMingLiU">第十二條：帳號與密碼之使用</font> </span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                  >1.&nbsp;乙方不得將個人之帳號、密碼轉移或出借予第三人使用，如造成糾紛，由乙方自行負責。</span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                  >2.&nbsp;乙方完成註冊程序後取得之帳號及密碼，該組帳號一經設定即不得變更。</span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                  >3.&nbsp;前項之密碼得依甲方提供之修改機制進行變更。甲方人員（包括客服人員，遊戲管理員）不得主動詢問、&nbsp;更改乙方之密碼。甲方應於合約終止後30日內（不得超過三十日），保留乙方之帳號及附隨於該帳號之電磁紀錄。</span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                  >4.&nbsp;合約非因可歸責乙方之事由而終止者，乙方於前項期間內進行續用後，有權繼續使用帳號及附隨於該帳號之電磁紀錄。</span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                >
                  <font face="PMingLiU"
                    >第十三條：電磁紀錄被不當移轉時之處理方式</font
                  > </span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                  >1.&nbsp;乙方如發現帳號，密碼被第三人非法使用時，應立即通知甲方並由甲方進行查證，經甲方確認有遭非法使用之情事後，得暫停該組帳號或密碼之使用權，更換密碼予乙方。</span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                  >2.&nbsp;甲方應於暫時限制遊戲使用權利之時起，即刻以官網公告，簡訊，電子郵件，推播或其他雙方約定之方式通知前項第三人提出說明。如該第三人未於發出通知時起七日內提出說明，甲方應直接恢復遭受不當移轉之電磁記錄予乙方，如不能恢復時可採其他雙方同意之相當補償方式。甲方有提供免費安全機制而乙方不使用或有其他可歸責於乙方之事由，甲方不負恢復或補償責任。</span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                  >3.&nbsp;第一項之第三人不同意甲方前項之處理時，得依報案程序，循司法途徑處理。</span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                  >4.&nbsp;甲方依第一項規定限制乙方或第三人之使用權時，在限制使用期間內，甲方不得向乙方或第三人收取費用。</span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                  >5.&nbsp;乙方如有申告不實之行為，造成致生乙方或第三人權利受損時，乙方應負一切法律責任。</span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                >
                  <font face="PMingLiU"
                    >第十四條：遊戲歷程之保存與查詢</font
                  > </span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                >
                  <font face="PMingLiU">甲方會保存乙方個人</font>
                  30日遊戲歷程記錄，乙方可透過官方客服系統申請調閱乙方個人遊戲歷程。乙方應提出個人資訊，如帳號，密碼，身分證明文件及其他可供佐證個人身分之資料以供甲方查驗身分。乙方必須負擔查詢費用新台幣貳佰元。 </span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                >
                  <font face="PMingLiU">第十五條：個人資料</font> </span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                >
                  <font face="PMingLiU">
                    對於乙方所註冊或留存之資料，乙方同意甲方及關係企業或合作對象，得於合理之範圍內蒐集、處理、保存、傳遞及使用相關資料，以提供會員其他資訊或服務或作成會員統計資料，關於進行網路行為之調查或研究或為任何之合法使用。
                  </font> </span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                >
                  <font face="PMingLiU">第十六條：隱私權政策</font> </span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                >
                  <font face="PMingLiU">
                    關於乙方的會員註冊以及其他特定資料依「個人資料保護法」受到保護與規範。乙方了解當乙方使用本服務時，乙方同意甲方依據「專有權政策」進行乙方個人資料的蒐集與利用，包括跨國間的傳輸與儲存及甲方及其關係企業內部之用。
                  </font> </span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                >
                  <font face="PMingLiU"
                    >第十七條：電磁記錄被不當移轉時之處理方式</font
                  > </span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                  >1.&nbsp;甲方應提供乙方各式安全機制，乙方如使用甲方提供之安全機制電磁記錄仍遭受不當移轉時，經甲方調查屬實，甲方無條件回復為不當移轉前之狀態。</span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                  >2.&nbsp;本遊戲服務之所有電磁紀錄（包括但不限於乙方操作遊戲所留存之電磁紀錄）均屬甲方所有，甲方應維持乙方相關電磁紀錄之完整。乙方對於電磁紀錄擁有使用支配之權利。但不包括本遊戲服務範圍外之移轉、收益行為。</span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                  >3.&nbsp;乙方如發現帳號、密碼被非法使用時，應立即通知甲方查證，經甲方確認有發生情事後，應依前條之方式處理之。</span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                >
                  <font face="PMingLiU">第十八條：服務之暫停或中斷</font> </span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                  >1.&nbsp;於以下事實發生時，甲方有權停止或中斷提供服務。</span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                  >a．&nbsp;系統及軟硬體設備進行例行性或必要性的維護。</span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                  >b．&nbsp;甲方伺服器的電子通信服務發生狀況或進行維護，導致無法連線。</span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                  >c．&nbsp;發生突發性之軟硬體設備與電子通信設備故障。</span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                  >d．&nbsp;由於天災等不可抗拒的因素，導致甲方系統無法進行。</span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                  >e．&nbsp;其他不可歸責於甲方所造成的服務停止或中斷。</span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                  >2.&nbsp;於前項a款之情況，甲方應於7日前於官網首頁、遊戲登錄頁面或購買頁面公告之。</span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                  >3.&nbsp;若有因可歸責甲方之情事，致乙方不能連線使用本遊戲服務時，甲方應立即更正或修復。對於乙方於無法使用期間遭受遊戲費用或遊戲內商品，甲方應返還遊戲費用或商品，無法返還時則應提供其他合理之補償。</span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                  >4.&nbsp;甲方依本合約之規定負有於提供本服務時，維護其自身電腦系統，符合當時科技或專業水準可合理期待之安全性之責任，如有系統或電磁紀錄遭受破壞或異常，應甲方違反前二項規定，致生乙方損害時，應依乙方之受損害賠償，負損害賠償責任，但甲方能證明其無過失者，得免除其賠償責任。</span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                  >5.&nbsp;甲方電腦系統發生上述第3項所稱情況時，於完成修復並正常運作之前，甲方不得向乙方收取費用。</span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                >
                  <font face="PMingLiU"
                    >第十九條：企業經營者及消費者責任</font
                  > </span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                  >1.&nbsp;甲方依本合約之規定，負有於提供本服務時維護其自身電腦軟、硬體系統，符合當時科技或專業水準可合理期待之安全性。</span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                  >2.&nbsp;甲方電腦系統或電磁紀錄受到破壞，或電腦系統運作異常時，甲方應於採取合理之措施後儘速盡快恢復。</span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                  >3.&nbsp;甲方違反前二項規定或因遊戲程序漏洞致生乙方損害時，應依乙方受損害賠償，負損害賠償責任。但甲方能證明其無過失者，得減輕其賠償責任。</span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                  >4.&nbsp;甲方電腦系統發生第二項之情況下，於完成修復並正常運作之前，甲方不得向乙方收取費用。</span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                  >5.&nbsp;乙方因共有帳號、委託他人購買點數而衍生與第三人間之糾紛，甲方得不予協助處理。</span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                >
                  <font face="PMingLiU"
                    >第二十條：服務使用之責任與義務</font
                  > </span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                  >1.&nbsp;乙方不得利用本會員服務進行任何商業行為，如濫發廣告訊息、郵件及宣傳性商業網站、遊戲外交易…等。</span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                  >2.&nbsp;除了遵守本服務條款外，乙方同意遵守網際網路國際使用慣例與禮節之相關規定。</span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                  >3.&nbsp;乙方不得利用本服務傳送、發表涉及辱罵、毀壞誹謗、不雅、淫穢、攻擊性之文章或圖片。</span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                  >4.&nbsp;乙方同意必須充分尊重智慧財產權，禁止發表侵害他人他人智慧財產權或其他權利之文字，圖片或任何形式之檔案。</span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                >
                  <font face="PMingLiU">第二十條：遊戲管理規則</font> </span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                  >1.&nbsp;為規範遊戲進行方式，甲方應訂定合理的遊戲管理規則，乙方應遵守甲方公告之遊戲管理規則。</span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                  >2.&nbsp;遊戲管理規則之變更應依第二十三條之程序為之。</span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                  >3.&nbsp;為進一步管理並維護甲方提供之遊戲品質，乙方同意甲方得於乙方於利用外掛程式、病毒程式、遊戲程式漏洞或其他違反公平合理之方式進行遊戲時，由系統自動紀錄留存包括所有乙方相關遊戲資料。</span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                >
                  <font face="PMingLiU"
                    >第二十一條：違反遊戲管理規則之處理</font
                  > </span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                  >1.&nbsp;除構成合約終止事由外，甲方依遊戲管理規則對乙方所為之處置，不得影響乙方依本合約應享之權利。</span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                  >2.&nbsp;除本合約另有規定外，有事實足證乙方於本遊戲服務中違反遊戲管理規則時，甲方應於官網、遊戲登錄頁面等公開平台進行公告，並依乙方登錄之通訊資料通知乙方。</span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                  >3.&nbsp;乙方首次違反遊戲管理規則，甲方應通知乙方於一定期間內改善。經甲方通知改善而未改善者，甲方得依遊戲管理規則，按其情節輕重限制乙方之遊戲使用權利。如乙方因同一事由再次違反遊戲管理規則時，甲方得立即依遊戲管理規則限制乙方進行遊戲之權利。</span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                >
                  <font face="PMingLiU">第二十二條：制定權利</font> </span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                  >1.&nbsp;乙方對於甲方提供之連線品質、遊戲管理、費用或其他相關之服務品質有所疑慮時，得於收到通知之翌日起七日內至甲方之電子郵件或書面提出建議，甲方應於接獲建議後15日內回覆處理之結果。</span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                  >2.&nbsp;甲方應於官網或遊戲管理規則中明定相關服務管道，包含電子郵件等相關聯絡資訊。</span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                  >3.&nbsp;乙方反映第三人利用外掛程式或其他影響遊戲公平性之舉，依第一項規定進行。</span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                >
                  <font face="PMingLiU"
                    >第二十三條：合約之終止及退費</font
                  > </span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                  >1.&nbsp;乙方了解所購買的點數，一經開卡或儲值後，即表示乙方已經於甲方之系統進行此項服務的消費。乙方存入會員帳號的服務點數、商品，將無法轉讓給第三人。</span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                  >2.&nbsp;因乙方違反本會員條款，遊戲管理規章者或法律時，遭甲方以永久停權方式處分時，視為終止本服務，甲方無須退還該會員已預付或儲值之服務點數或金額，甲方若有遭受其他損害，將追究乙方法律責任。</span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                  >3.&nbsp;若甲方無法收到會員通過網上刷卡、小額支付或其他非使用現金的方式購買商品或使用服務的費用時，甲方有權終止乙方之帳號或其他會員服務。</span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                  >4.&nbsp;乙方得隨時提出終止本契約之申請，甲方將依申請而終止該會員服務，並據此扣除必要的費用（30％）後，退還所購買但尚未使用之點數，退還點數不包含乙方非實際消費或活動贈送之部分。</span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                  >5.&nbsp;甲方視實際情況保留終止乙方服務之全部或一部分之權利，當服務終止發生時，乙方得向甲方申請剩餘點數之退費，甲方扣除必要的費用（&nbsp;30％）後，退還乙方與尚未使用之點數相當之金額，退還點數不包含乙方非實際消費或活動贈送之部分。</span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                  >6.&nbsp;甲方得與乙方約定，若乙方逾時一年未登錄使用本遊戲服務，甲方得定一個月前通知乙方登錄，如乙方屆期仍未登錄使用，則甲方得終止本合約。</span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                  >7.&nbsp;合約終止時，甲方於扣除30％必要成本後，應於三十日內以現金、信用卡、匯票或掛號寄發支票方式退還乙方未使用之發現購買之點數或遊戲費用，或依雙方同意之方式處理終止點數或費用。退還費用不包含乙方經遊戲、活動給予或其他非乙方實際消費儲值所獲得的部分。</span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                  >8.&nbsp;乙方有下列重大情事之一者，甲方依乙方登錄之通訊資料或公開平台公告通知乙方後，得立即終止本合約：</span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                  >a．利用任何系統或工具對甲方電腦系統之惡意攻擊或破壞。</span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                  >b．利用外掛程式、病毒程式或其他違反遊戲常態設定或公平合理之方式進行遊戲。</span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                  >c．以冒名、詐騙或其他虛偽不正等方式購買點數或遊戲內商品，或點數儲值後拒付款項或違反第七條遊戲點數之內容者。</span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                  >d．因同一事由違反遊戲管理規則達三次以上而未改善者。</span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                  >e．乙方於甲方提供之服務範圍，進行不法行為遭司法機關查獲者。</span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                  >f．以類似甲方名稱或不雅文字作為註冊名稱使用本服務者。</span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                  >g．冒用他人名義或身分資料申請甲方服務者。</span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                  >h．在遊戲中發表任何有背於公共秩序或善良風俗之內容。</span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                  >i．透過本服務或在其他平台，與他人進行遊戲貨幣或遊戲道具之交易行為。</span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                  >9.&nbsp;本合約終止後超過第十五條規定之保存期間，乙方會失去購買的任何已兌換、購買之遊戲商品；或甲方對前項事實認定產生錯誤或無法舉證時，甲方應對乙方之損害負賠償責任。虛擬物品，如角色資料，裝備，道具等任何帳號相關的遊戲電磁記錄。</span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                >
                  <font face="PMingLiU">第二十五條：停止營運</font> </span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                  >1.&nbsp;因甲方停止本遊戲服務之營運而終止合約者，應於停止終止前30日公告於官網首頁、遊戲登錄頁面或購買頁面，並依乙方登錄之通訊資料通知乙方。</span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                  >2.&nbsp;甲方未依前項期間公告並通知，除應退還乙方未使用之發現購買點數或遊戲費用且不得取代必要的成本外，並應提供其他合理之補償。</span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                >
                  <font face="PMingLiU">第二十六條：送達</font> </span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                  >1.&nbsp;有關本合約所有事項之通知，乙方同意甲方依乙方登錄之通訊資料為送達。</span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                  >2.&nbsp;前項登錄通訊資料若有變更，乙方應即通知甲方。甲方應依變更後之通訊資料為送達。</span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                  >3.&nbsp;乙方依甲方登錄之通訊資料之通知發出後，以甲方之發出記錄推定為已送達。</span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                  >4.&nbsp;因乙方之故意、過失或通訊資料造假，致甲方無法送達者，甲方不負責因無法送達所致乙方之損害賠償責任。</span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                >
                  <font face="PMingLiU">第二十七條：法條適用依據</font> </span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                >
                  <font face="PMingLiU"
                    >本合約與相關遊戲管理規範，遊戲規則之解釋及適用，以及乙方因使用本服務而與甲方間所生之權利義務關係，雙方同意以遊戲營運方所在地法律為準據法。</font
                  > </span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                >
                  <font face="PMingLiU">第二十八條：管轄法院</font> </span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                >
                  <font face="PMingLiU">
                    因本服務合約涉及的一切爭辯，雙方合意以臺灣臺北地方法院為第一審法院，但前開約定不排除消費者保護法第四十七條及以上民事訴訟法第二十八條第二項，第四百三十六條之九規定小額訴訟訴訟法院之適用。</font
                  > </span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                >
                  <font face="PMingLiU">附件：遊戲管理規則</font> </span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                >
                  <font face="PMingLiU"
                    >若有以下情況發生，將進行停權數日甚至永久之處分，官方擁有最終解釋權，並得依情節輕重調整處罰之內容。</font
                  > </span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                  >1.&nbsp;言論不當：</span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                >
                  <font face="PMingLiU">若有下述情形將進行停權處分：第一次</font
                  >3天、第二次7天、第三次永久停權。 </span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                  >a.&nbsp;於官網、遊戲頻道中發送包含低級、褻瀆、粗魯、謾罵、誹謗、人身攻擊、威脅、挑釁、種族與性別歧視、不雅文字、猥褻及含有色情內容或含意，有違社會善良風俗者，本公司有權判定其處分，同時會員需自負法律責任。</span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                  >b.&nbsp;於公開頻道重複發表多次言論，造成其他會員無法正常觀看頻道之事實，如：持續無意義的內容，使用相同之文字進行重覆且有頻率的方式發言等，皆構成洗頻。</span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                  >c.&nbsp;任何非本公司所允許之商業廣告。</span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                  >d.&nbsp;違反個人隱私資料的保護及影響第三人權益與隱私之言詞內容。</span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                  >e.&nbsp;任何種族歧視或對孩童有不良影響的言詞內容。</span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                  >f.&nbsp;不當攻擊、影射貶低他人及其家人。</span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                  >g.&nbsp;侵犯任何第三人的智慧財產權，版權或公眾/私人權利。</span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                  >h.&nbsp;發布違反任何法律規定，善良風俗之內容與行為。</span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                  >i.&nbsp;提供虛偽不正的儲值方式，得直接處永久停權處分。</span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                  >j.&nbsp;非法造假、曲解資料回報刻意污衊他人，或提供錯誤資訊造成其他會員權益所有權損失等行為。</span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                  >2.&nbsp;惡意擾亂遊戲進行：</span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                >
                  <font face="PMingLiU"
                    >若有以下情況發生，將進行停權處分：：第一次</font
                  >3天、第二次7天、第三次永久停權。 </span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                  >a.&nbsp;意圖減緩客服處理問題速度，重複問題回報或回報無意義之字句達三次(含三次)以上。</span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                  >b.&nbsp;資料填答不實或不全，阻止客服人員服務運作者。</span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                  >c.&nbsp;使用各種客服回報管道服務時，所提供的內容包含攻擊、不雅、猥褻之意，或涉及對本公司及所屬員工進行騷擾、誹謗、言論攻擊，影響客服人員及客服中心作業。</span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                  >d.&nbsp;妨害GM或故意損害GM工作的行為。</span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                  >e.&nbsp;持續危害特定其他玩家進行遊戲，或相似的情況。</span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                  >f.&nbsp;在遊戲內謊稱為GM或工作人員，要求他人的個人資料。</span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                  >g.&nbsp;散佈本公司沒有公告的偽造事實。</span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                  >h.&nbsp;任意修改公告或散佈修改內容的行為。</span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                  >3.&nbsp;騷擾遊戲管理員：</span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                >
                  <font face="PMingLiU"
                    >若有以下情況發生，將進行停權處分：第一次</font
                  >3天、第二次7天、第三次永久停權。 </span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                  >a.&nbsp;本公司於各遊戲中所分配的遊戲管理員，有權立即暫停任何可能危害遊戲系統的遊戲帳號上線權利或相關線上活動，所有遊戲管理員都將嚴格按照中立和公正原則、不偏袒、不徇私。</span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                  >b.&nbsp;遊戲內遊戲管理員職責主要為遊戲中違規查緝，維護遊戲內秩序，鼓動相關線上活動，將不主動回覆線上會員詢問的問題。</span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                  >c.&nbsp;若在線上無意義密頻遊戲管理員或連續插入洗頻，將視情節輕重進行糾正。</span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                  >4.&nbsp;遊戲帳號：</span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                >
                  <font face="PMingLiU"
                    >若有以下情況發生，將進行停權處分：第一次</font
                  >
                  3天、第二次7天、第三次永久停權。同一個IP位址於&nbsp;24小時之內創立三個(含三個)以上帳號，並同時登入遊戲。 </span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                  >a.&nbsp;基於非正常進行遊戲，而使用相似、相關、流水號或有特定規則命名的帳號創立。</span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                  >5.&nbsp;惡意洗貨幣，道具，戰績或經驗等：</span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                >
                  <font face="PMingLiU"
                    >若有以下情況發生，將進行停權處分：第一次</font
                  >7天，第二次永久停權。 </span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                  >a.&nbsp;使用者帳號在遊戲中與其他使用者帳號串通進行嚴重洗戰績等故意放水行為，造成其他使用者帳號損失者，所有參與或協助違反規範之會員懲處。</span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                  >b.&nbsp;發現有異常行為，將道具、遊戲幣、點數等流通交易或集中特定帳號，灌洗績分／經驗值等行為。</span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                  >6.&nbsp;散播使用非法遊戲方式：</span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                >
                  <font face="PMingLiU"
                    >若有以下情況發生，將進行停權處分：第一次</font
                  >7天，第二次永久停權。 </span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                  >a.&nbsp;散播涉及以現實生活中的金錢或有價物，進行交易或交換「道具」、「遊戲幣」等電磁記錄之行為（包含涉及散佈，播送或擴展引入引誘，中介，暗示或其他推進人為現金交易之廣告行為訊息者）。</span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                >
                  <font face="PMingLiU">
                    注：所有現金交易純屬會員個人之行為，若以非官方許可管道取得包含但不延續戰績、排位、勝率發生任何問題，需由其他會員自行承擔，本公司一概不負責，本公司會配合提供相關資料以利警方查案。</font
                  > </span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                  >b.&nbsp;以不當方式取得之遊戲利益，除停權外官方得沒收非法遊戲期間所獲得之不當利益。</span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                  >7.&nbsp;使用不當程式進行遊戲：</span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                >
                  <font face="PMingLiU"
                    >若有以下情況發生，將進行停權處分：第一次</font
                  >7天，第二次永久停權。 </span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                  >a.&nbsp;直接或間接安裝／開啟執行，使用或散佈非官方提供的不當程式、私服，包含但不限加速器、按鍵精靈、搖桿連點功能、開圖程式或泛指外掛等輔助工具，程式等非法工具破壞遊戲的平衡性。</span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                  >b.&nbsp;遊戲進行時，會員必須在遊戲終端裝備前進行遊戲，若會員不在，但其人物角色仍然在進行需人為手動操作之動作，則該情況皆稱為機器人角色（Robot）；經GM查緝並記錄情況後，將按照違規罰責進行處理。</span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                  >c.&nbsp;被查獲者必須正確回應查獲偵查專員的詢問，不得以無意義的文字，重複或答非所問之對話回應查獲，包括但不限於：他人代為進行遊戲，看不懂文字，逃離現場，離開遊戲，對話檢視關閉或遊戲視角無法觀察周圍或其他原因等，規避查緝起訴專員的詢問及測試，並且禁止對查獲人員進行恐嚇或謾罵等行徑。如果被查獲者持續進行動作，卻未正確回應查獲起訴專員詢問，將視同使用外掛／輔助程序並依據遊戲規則章懲處。</span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                  >d.&nbsp;在論壇、各遊戲頻道宣傳外掛網址、外掛名稱，或邀請、傳授其他用戶使用任何非官方提供的輔助程序、外掛程序、加速程序、修改程序…等非法工具，均以散佈外掛論處，本公司得停止其會員之使用權。</span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                  >e.&nbsp;針對使用或散佈外掛嚴重者，將取消其會員帳號，並記錄裝置、IP位址等資訊予以停權；經移轉的遊戲幣及寶物，視同非法物品一併追查回收。</span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                  >8.&nbsp;涉及盜用或詐騙其他會員物品：</span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                >
                  <font face="PMingLiU"
                    >若有以下情況發生，將進行停權處分：第一次</font
                  >7天，第二次永久停權。 </span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                  >a.&nbsp;盜用或涉及詐騙其他會員物品，包含但不限於帳號、會員資料、道具、遊戲幣、點數，官方將終止其會員之使用權。</span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                  >b.&nbsp;如因個人行為涉及司法案件者，或經司法機關查獲起訴任何不法之行為者，本公司得終止其會員之使用權。</span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                  >c.&nbsp;經移轉的帳號、會員資料、道具、遊戲幣、點數視同非法物品將一併追查回收。</span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                  >9.&nbsp;9.&nbsp;進行、宣傳或發表違反法律之行為：</span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                >
                  <font face="PMingLiU"
                    >若有以下情況發生，將進行停權處分：第一次</font
                  >7天，第二次永久停權。 </span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                >
                  <font face="PMingLiU"
                    >會員利用本公司提供的服務發送違反法律之內容，包括但不限於：賭博、教唆犯罪、販賣毒品、槍械等不法物品，涉及引入援交、色情，不法仲介等。</font
                  > </span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                  >10.&nbsp;破壞，入侵，篡改或破解任一遊戲程序／伺服器／用戶端資料：</span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                >
                  <font face="PMingLiU"
                    >若有以下情況發生，將進行停權處分：第一次即永久停權。</font
                  > </span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                  >a.&nbsp;不得侵入，攔截，破壞，破解，修改，逆溯，編譯，變更原始程序，伺服器端或用戶端資料。</span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                  >b.&nbsp;以不當方式篡改遊戲帳號密碼，複製更改封包值等，更動遊戲內容資料或對遊戲進行其他不當方式使用。</span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                  >c.&nbsp;對遊戲程序及網頁機制進行軟件轉換工程，為任何更改原始程序系統上的鎖定與解除鎖定，以其他不當方法更改會員遊戲帳號，密碼，或以復制更改封包值之手段更改遊戲內容資料或為其他不當使用方式。</span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                  >d.&nbsp;若有上述情形發生，將進行處分：第一次即永久停權</span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                  >11.&nbsp;利用遊戲漏洞進行遊戲：</span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                >
                  <font face="PMingLiU"
                    >若有以下情況發生，將進行停權處分：第一次</font
                  >7天，第二次永久停權。 </span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                  >a.&nbsp;由官方提供之測試或免費試玩期間，因遊戲BUG而產生的物品，等級，金錢回溯，將不負責賠償。</span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                  >b.&nbsp;利用遊戲中之BUG或規則不盡完善之處，以違反公平合理之方式、手段進行遊戲，甚至造成伺服器負擔加重或當機等，讓自己受惠及牟利他人，導致遊戲失衡之行為，BUG將以本公司認定為主。</span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                  >c.&nbsp;利用BUG而獲得或複製遊戲中之虛擬寶物、裝備、屬性能力、經驗值、角色資料、等級或其他任何利益…等，而造成遊戲不平衡，與影響其他會員權益及造成不屬於原先設計範圍效果，所有關係者經查證屬實後之一切資料，將視情況回收會員利用BUG進行遊戲而直接、間接獲得之非法權益。</span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                  >d.&nbsp;類別BUG觸發方式在遊戲內部公眾區域以任何方式公開討論。</span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                  >12.&nbsp;意圖現金購買或販賣遊戲幣或道具：</span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                >
                  <font face="PMingLiU"
                    >若有以下情況發生，將進行停權處分：第一次</font
                  >7天，第二次永久停權。 </span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                  >a.&nbsp;凡於遊戲內使用包含但不限於：買賣T幣、T、數字網、金幣、小朋友，台幣等影射現金交易之字詞。</span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                  >b.&nbsp;針對本公司禁止之交易行為，除進行帳號停權處分外，經移轉的遊戲幣，道具等電磁記錄將視情況回收。</span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                  >c.&nbsp;涉及對遊戲虛寶、遊戲幣、點數或點數卡等，以現實生活中的金錢或有價物，進行交易或交換之行為。</span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                  >d.&nbsp;所有現金交易純屬會員個人之行為，若以非官方許可管道取得之點數、遊戲幣、道具發生任何問題，需由其他會員自行承擔，本公司一概不負責，本公司會配合提供相關資料以利警察查案。</span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                  >13.&nbsp;利用非法機制取得遊戲幣或道具：</span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                >
                  <font face="PMingLiU"
                    >若有以下情況發生，將進行停權處分：第一次</font
                  >7天，第二次永久停權。 </span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                  >a.&nbsp;包含但不限於利用系統異常、BUG、非法機制、非法程序所引起的物品之行為，或詐騙、盜用其他會員物品，以及不當接收物品的行為。</span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                  >b.&nbsp;經移轉的遊戲幣及寶物視同非法物品將視情況一併追查回收。</span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                  >14.&nbsp;意圖現金買賣會員帳號：</span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                >
                  <font face="PMingLiU"
                    >若有以下情況發生，將進行停權處分：第一次</font
                  >7天，第二次永久停權。 </span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                >
                  <font face="PMingLiU"
                    >不可使用任何形式或代價買賣會員帳號若會員帳號經移轉，或為兩人以上共同如果有上述情況發生，將進行處分。</font
                  > </span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                  >15.&nbsp;假冒官方人員：</span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                >
                  <font face="PMingLiU"
                    >若有以下情況發生，將進行停權處分：第一次</font
                  >7天，第二次永久停權。 </span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                >
                  <font face="PMingLiU">
                    包含但不限於假冒官方人員名義、使用類似官方帳號、以官方口吻或語氣引導或企圖導致其他會員誤會之方式來舉辦活動、發布消息、進行詐欺、不當評論發表或任何其他其他會員正常進行遊戲之舉止。</font
                  > </span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                  >16.&nbsp;共用帳號破壞遊戲平衡</span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                >
                  <font face="PMingLiU"
                    >若有以下情況發生，將進行停權處分：第一次</font
                  >7天，第二次永久停權。 </span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                  >a.&nbsp;將帳號交付他人使用或使用他人帳號，導致破壞遊戲平衡。</span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                  >b.&nbsp;會員應妥善保管帳號與密碼，不得將帳號密碼轉移、交付、揭露或出借予第三人，若將帳號所有權他人共同使用而與本公司或其他會員產生糾紛，導致任何關於帳號停權、虛寶、點數、等級、排名、積分等糾紛，無論有無啟用官方防盜機制，會員必須自行承擔所有損失。</span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                  >17.&nbsp;儲值異常：</span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                >
                  <font face="PMingLiU"
                    >若有以下情況發生，將進行停權處分：第一次即永久停權。</font
                  > </span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                  >a.&nbsp;儲值來源異常。</span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                  >b.&nbsp;帳號所存值的點數來源經甲方查核為異常或有第三人向警察報案涉及欺詐騙局或其他刑事案件時。</span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                  >c.&nbsp;經金流平台反應點數儲值異常者。</span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                  >18.&nbsp;惡意利用公司與商店：</span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                >
                  <font face="PMingLiU"
                    >若有以下情況發生，將進行停權處分：第一次即永久停權。</font
                  > </span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                  >a.&nbsp;惡意利用公司與商店所提供的會員加入、遊戲使用、交易等相關基本流程，獲取不當所得的行為。</span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                  >b.&nbsp;惡意利用商店基本流程的方法，進行傳播/散佈。</span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                  >19.&nbsp;駭客行為：</span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                >
                  <font face="PMingLiU"
                    >若有以下情況發生，將進行停權處分：第一次即永久停權。</font
                  > </span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                  >a.&nbsp;企圖侵入其他玩家的手機、電腦，或發布相關內容的行為。</span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                  >b.&nbsp;變更或修改遊戲資料的行為。</span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                  >c.&nbsp;透過駭客行為獲得不當利益或破壞遊戲平衡的行為。</span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                  >d.&nbsp;操作所有遊戲相關資料，獲得不當利益的行為。</span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                  >e.&nbsp;如果有上述情況發生，將進行處分：第一次即永久停權。</span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                  >20.&nbsp;假造會員資料：</span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                >
                  <font face="PMingLiU"
                    >若有以下情況發生，將進行停權處分：第一次即永久停權。</font
                  > </span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                  >a.&nbsp;使用非本人之資料註冊會員，經查證為假造資料屬實者。</span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                  >b.&nbsp;會員若故意登載不實之個人資料已構成違約事由，本公司得終止並重置其會員號碼，且不負任何賠償損失責任。如因此導致本公司有損失，本公司將予以相關賠償及懲罰性違約金，同時會員應自負因該行為所衍生的一切一切民事刑事責任（包括但不限於刑法偽變造文書，詐欺，篡改電磁紀錄等相關罪章）。</span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                  >c.&nbsp;若有上述情形發生，將進行處分：第一次即永久停權。</span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                  >21.&nbsp;洩漏個人資料：</span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                >
                  <font face="PMingLiU"
                    >若有以下情況發生，將進行停權處分：第一次</font
                  >7天，第二次永久停權。 </span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                  >a.&nbsp;在遊戲內外洩其他玩家個人資料的行為。</span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                  >b.&nbsp;在遊戲內要求其他玩家個人資料的行為。</span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                  >22.&nbsp;不當名稱、頭像圖片：</span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                >
                  <font face="PMingLiU"
                    >若有上述情況發生，將進行處分：第一次強制更名或停權</font
                  >7天，第二次停權７天，第三次永久停權。 </span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                  >a.&nbsp;會員使用包含利用直接，間接，影射一般的髒話、污穢以及類似相詞等方式，與文字組合後具有定義的遊戲名稱或頭像圖片皆不被允許。</span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                  >b.&nbsp;包含低級、褻瀆、粗魯、辱罵、誹謗、人身攻擊、威脅、挑釁、種族、國別、地區與性別歧視、不雅文字、猥褻及煽情、具有色情內容或含意，對孩童有不良影響或影響其他會員進行遊戲觀感。</span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                  >c.&nbsp;具有特定或商業廣告性質。</span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                  >d.&nbsp;有害第三人權益與隱私或影射他人的名稱。</span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                  >e.&nbsp;違反任何法律或善良風俗，具有犯罪行為或教唆犯罪。</span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                  >f.&nbsp;若角色名稱包含特殊字元，空白字元或特殊符號或類似官方人員名稱，將視情況直接強制更名。</span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p class="MsoNormal">
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 10.5pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="footer">
      <!-- <p>香港鈴六網絡科技有限公司</p>
            <p>Guangzhou Lulin Technology Co. LTD</p>
            <p>广州市天河区棠下荷光三横路13号301房</p> -->
      <div class="leftP">
        <img :src="require('../../../../public/image/12.png')" alt="" />
        <img :src="require('../../../../public/image/11.png')" alt="" />
      </div>
      <div class="rightP">
        <div class="pwarp">
          <p>※本軟體因涉及暴力、打鬥，依遊戲軟體分級管理辦法分類為輔12級</p>
          <p>※遊戲內提供購買虛擬遊戲幣、物品等付費服務</p>
          <p>※請注意遊戲時間，避免沉迷</p>
          <p>※共和國科技有限公司為在台港澳地區的授權代理商。</p>
        </div>
      </div>
      <!-- <p>香港鈴六網絡科技有限公司</p>
        <p>LINGLUK NETWORK TECHNOLOGY LIMITED</p>
        <p>
          Room 101A, 1/F., Genplas Industrial Building, 56 Hoi Yuen Road, Kwun
          Tong, Kowloon
        </p> -->
    </div>
  </div>
</template>

<script>
import '../../../../public/js/jquery.min.js'

export default {
  name: 'crossgateTerms',
  mounted() {
    $('#focus .imgs ul').width(
      $('#focus .imgs li').length * $('#focus').width()
    )
    $('#focus .ctrl a:eq(0)').addClass('on')
    var focusT

    function focus() {
      focusT = setInterval(function () {
        var i = $('#focus .ctrl a.on').index('#focus .ctrl a') || 0,
          l = $('#focus .ctrl a').length
        i++
        if (i > l - 1) i = 0
        $('#focus .ctrl a').removeClass('on').eq(i).addClass('on')
        $('#focus .imgs ul')
          .stop(true, true)
          .animate(
            {
              left: -$('#focus').width() * i
            },
            600
          )
      }, 8000)
    }
    focus()
    //幻灯
    $('#focus .ctrl a').click(function () {
      clearInterval(focusT)
      var i = $(this).index('#focus .ctrl a')
      $('#focus .ctrl a').removeClass('on').eq(i).addClass('on')
      $('#focus .imgs ul')
        .stop(true, true)
        .animate(
          {
            left: -$('#focus').width() * i
          },
          600,
          function () {
            focus()
          }
        )
    })

    $('.sectionC .next,.sectionC .prev').click(function () {
      var i = $('.sectionC .ctrl a.on').index() || 0,
        l = $('.sectionC .ctrl a').length
      if ($(this).hasClass('next')) {
        i++
        if (i > l - 1) i = 0
      } else {
        i--
        if (i < 0) i = l - 1
      }
      $('.sectionC .ctrl a').removeClass('on').eq(i).addClass('on')
      $('.sectionC .imgs li').removeClass('on').eq(i).addClass('on')
    })
    //特色
    $('.sectionC .ctrl a').click(function () {
      var i = $(this).index()
      $('.sectionC .ctrl a').removeClass('on').eq(i).addClass('on')
      $('.sectionC .imgs li').removeClass('on').eq(i).addClass('on')
    })
    //场景
    $('#scene .ctrl a').click(function () {
      var i = $(this).index('#scene .ctrl a')
      $('#scene .ctrl a').removeClass('on').eq(i).addClass('on')
      $('#scene .imgs li').hide().eq(i).fadeIn(800)
    })
    $('.sider a').click(function () {
      var i = $(this).index()
      if (i < 4) {
        $('html,body').animate(
          {
            scrollTop: $('.section').eq(i).offset().top
          },
          500
        )
      }
    })

    function play_image_list(elementID, effect, play_time) {
      var _div = $('.' + elementID + ' ul')
      var temp_time
      if (_div.children('li').length <= 4) {
        return false
      }
      //play_img("left");
      _div.width(
        _div.children('li').length * (_div.children('li').eq(0).width() + 20)
      )
      if (effect === 'continue') {
        play_time = 30
        _div.css('margin-left', '0px')
      }
      temp_time = setTimeout(function () {
        play_img('left')
      }, play_time)
      _div.parent().hover(
        function () {
          clearTimeout(temp_time)
        },
        function () {
          temp_time = setTimeout(function () {
            play_img('left')
          }, play_time)
        }
      )

      function play_img(type) {
        if (temp_time) {
          clearTimeout(temp_time)
        }
        var div_f = $('.' + elementID + ' ul>li:first'),
          div_l = $('.' + elementID + ' ul>li:last'),
          div_width = div_f.width()
        //alert(div_width);
        if (effect === 'continue') {
          play_time = 30
          var num =
            _div[0].style.marginLeft == '0px'
              ? parseInt(_div[0].style.marginLeft)
              : parseInt(_div[0].style.marginLeft.substring(1))
          num++
          if (num <= div_width + 20) {
            _div.css('margin-left', -num + 'px')
          } else {
            _div.append(div_f)
            _div.css('margin-left', '0px')
          }
        }
        temp_time = setTimeout(function () {
          play_img('left')
        }, play_time)
        return false
      }
    }

    function minWidth() {
      var isIE6 = !-[1] && !window.XMLHttpRequest
      //if(!isIE6){return false;}
      var num = 980
      var w_width = $(window).width()
      if (w_width > num) {
        $('body').width('100%')
      } else {
        $('body').width(980)
      }
    }
    play_image_list('logs', 'continue', 4000)
    var my_jPlayer

    function scrollTxt() {
      var controls = {},
        values = {},
        t1 = 300,
        /*播放动画的时间*/
        t2 = 4000,
        /*播放时间间隔*/
        si
      controls.rollWrap = $('#roll-wrap')
      controls.rollWrapUl = controls.rollWrap.children()
      controls.rollWrapLIs = controls.rollWrapUl.children()
      values.liNums = controls.rollWrapLIs.length
      values.liHeight = controls.rollWrapLIs.eq(0).height()
      values.ulHeight = controls.rollWrap.height()
      this.init = function () {
        autoPlay()
        pausePlay()
      }
      /*滚动*/
      function play() {
        controls.rollWrapUl.animate(
          {
            'margin-top': '-' + values.liHeight
          },
          t1,
          function () {
            $(this).css('margin-top', '0').children().eq(0).appendTo($(this))
          }
        )
      }

      /*自动滚动*/
      function autoPlay() {
        /*如果所有li标签的高度和大于.roll-wrap的高度则滚动*/
        if (values.liHeight * values.liNums > values.ulHeight) {
          si = setInterval(function () {
            play()
          }, t2)
        }
      }

      /*鼠标经过ul时暂停滚动*/
      function pausePlay() {
        controls.rollWrapUl.on({
          mouseenter: function () {
            clearInterval(si)
          },
          mouseleave: function () {
            autoPlay()
          }
        })
      }
    }
    new scrollTxt().init()
  }
}
</script>

<style lang='scss' scoped src='../../../../public/css/home.css'></style>
<style lang='scss' scoped src='../../../../public/css/copy.css'></style>
<style lang='scss' scoped src='../../../../public/css/black.css'></style>
<style lang="scss" scoped>
.center {
  position: relative;
  height: 100%;
}
.centerBody {
  position: absolute;
  padding: 10px;
  border: 2px solid #fff;
  border-radius: 10px;
  background: rgba($color: #000000, $alpha: 0.5);
  bottom: 50px;
  left: 50%;
  width: 80%;
  transform: translateX(-50%);
  display: block;
  height: 150px;
  .leftWarp {
    float: left;
    div {
      a {
        display: block;
        img {
          width: 50%;
          padding: 5px;
          box-sizing: border-box;
          display: inline-block;
          float: left;
        }
      }
    }
  }
  .rightWarp {
    padding: 0px;
    position: relative;
    padding-left: 50px;
    height: 100%;
    div {
      height: 150px;
      border: 1px solid #fff;
      border-radius: 5px;
      box-sizing: border-box;
      a {
        display: block;
        width: 100%;
        height: 100%;
        img {
          padding: 5px;
          width: 100%;
          height: 100%;
          // height: 100%;
          display: block;
          box-sizing: border-box;
        }
      }
    }
  }
}
.sectionA {
  height: calc(100vw * 1440 / 2560 - 90px - 120px);
}
.footer {
  display: block;
  text-align: center;

  .leftP {
    // float: left;
    display: inline-block;
    height: 120px;
    // width: 50%;
    overflow: hidden;
    vertical-align: middle;
    img {
      width: 80px;
      height: 80px;
      float: right;
      padding: 20px 10px;
    }
  }
  .rightP {
    height: 120px;
    display: inline-block;
    text-align: left;
    vertical-align: middle;
    overflow: hidden;
    .pwarp {
      display: inline-block;
      overflow: hidden;
      padding: calc((120px - 72px) / 2);
      padding-left: 10px;
    }
    p {
      font-size: 14px;
      line-height: 18px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/route/src/crossgateTw/terms/index.vue